module.exports = __webpack_public_path__ + "img/gardesh-gari-offline-card.f40ce0c6.png";